var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2.25a.75.75 0 0 0-1.5 0v2.167h-.708a2.792 2.792 0 1 0 0 5.583H8v2.583H5.25a.75.75 0 0 0 0 1.5H8v2.167a.75.75 0 0 0 1.5 0v-2.167h.708a2.792 2.792 0 1 0 0-5.583H9.5V5.917h2.75a.75.75 0 0 0 0-1.5H9.5V2.25zM8 5.917h-.708a1.292 1.292 0 1 0 0 2.583H8V5.917zM9.5 10v2.583h.708a1.292 1.292 0 1 0 0-2.583H9.5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrrency);
export default __webpack_public_path__ + "static/media/сurrency.f079a17b871878c5f780f586a8f70fb9.svg";
export { ForwardRef as ReactComponent };